export default __webpack_public_path__ + "static/media/workplace.97e1c071.png";